/*
 * @Author: changcheng
 * @LastEditTime: 2023-04-20 09:45:04
 */
import { useEffect, useState } from "react";
import Header from "@/components/header/index";
import { useQuery } from "@/common/utils";
import axios from "@/axios/axios";
import "./index.less";
import { List, Breadcrumb } from "antd";
import { Link } from "react-router-dom";
const DemeanorInfo = () => {
  const query = useQuery();
  const [teacherinfo, setTeacherInfo] = useState<any>({});
  /**
   * 获取教师详情以及相关项目详情
   */
  const getTeacherProjectInfo = async () => {
    const id = query.get("id");
    const { data }: any = await axios.post(
      `/shop/front/ce/item/teacher/${id}`,
      {}
    );
    setTeacherInfo(data);
  };
  useEffect(() => {
    getTeacherProjectInfo();
  }, []);
  return (
    <div
      style={{
        background: "#fafafa",
      }}
    >
      <div className="demeanor-container">
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/index/home">首页</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>专家详情</Breadcrumb.Item>
        </Breadcrumb>
      </div>
      <div className="teacherInfo-box">
        <h3>{teacherinfo.name}</h3>
        <p>
          <img src={teacherinfo.imageAllPath} alt="" />
        </p>
        <p>{teacherinfo.workUnit}</p>
        <div style={{padding:"0 20%"}}>
         <p  dangerouslySetInnerHTML={{__html:teacherinfo.introduction}}></p>
        </div>
        {teacherinfo.itemList && teacherinfo.itemList.length > 1 && (
          <div className="project_info">
            <h3>相关项目</h3>
            {teacherinfo.itemList.map((item: any) => (
              <p
                style={{
                  color: "#4d7ffd",
                }}
              >
                {item.itemName}
              </p>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
export default DemeanorInfo;
